var map = {
	"./DROP_DOWN.svg": 366,
	"./ic_arbitrum_16.svg": 914,
	"./ic_avalanche_16.svg": 915,
	"./ic_avax_40.svg": 547,
	"./ic_bnb_40.svg": 548,
	"./ic_btc_40.svg": 400,
	"./ic_coingecko_16.svg": 916,
	"./ic_convert_down.svg": 917,
	"./ic_copy_16.svg": 918,
	"./ic_eth_40.svg": 401,
	"./ic_frax_40.svg": 549,
	"./ic_glp_24.svg": 550,
	"./ic_glp_40.svg": 551,
	"./ic_link_40.svg": 552,
	"./ic_metamask_16.svg": 919,
	"./ic_mim_40.svg": 553,
	"./ic_new_link_16.svg": 920,
	"./ic_settings_16.svg": 921,
	"./ic_sign in_16.svg": 922,
	"./ic_sign_out_16.svg": 923,
	"./ic_uni_40.svg": 554,
	"./ic_usdc.e_40.svg": 555,
	"./ic_usdc_40.svg": 556,
	"./ic_usdt_40.svg": 557,
	"./ic_wavax_40.svg": 558,
	"./ic_wbnb_40.svg": 559,
	"./ic_weth_40.svg": 560,
	"./lever.svg": 924,
	"./long.svg": 925,
	"./short.svg": 926,
	"./swap.svg": 927,
	"./swapup.svg": 928,
	"./wave-01.png": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 913;